module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "dedication",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("For my father")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Peter C. Herring, LCSW")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("with love from your lamb chop")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056b4fba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-3-32.vue
// module id = 69
// module chunks = 0